import { FileType } from '@/shared/graphql/router/graphql'
import type { CopyrightFile } from '@/features/copyright/composables/useCopyrightFile'

type FileEntity = Pick<CopyrightFile['owner'], 'id' | 'name' | 'avatar'>

const FILE_TYPE_LABELS: Record<FileType, string> = {
  [FileType.AdobeAfterEffects]: 'After Effects',
  [FileType.AdobeAudition]: 'Audition',
  [FileType.AdobeIllustrator]: 'Illustrator',
  [FileType.AdobeIndesign]: 'InDesign',
  [FileType.AdobePhotoshop]: 'Photoshop',
  [FileType.AdobePremierPro]: 'Premiere Pro',
  [FileType.Audio]: 'Audio',
  [FileType.AutodeskAutocad]: 'AutoCAD',
  [FileType.AutodeskFusion]: 'Fusion',
  [FileType.AutodeskMaya]: 'Maya',
  [FileType.Cinema_4D]: 'Cinema 4D',
  [FileType.Code]: 'Code',
  [FileType.DavinciResolve]: 'DaVinci Resolve',
  [FileType.Generic]: 'File',
  [FileType.Image]: 'Image',
  [FileType.MsAccess]: 'Access',
  [FileType.MsExcel]: 'Excel',
  [FileType.MsPowerPoint]: 'PowerPoint',
  [FileType.MsPublisher]: 'Publisher',
  [FileType.MsWord]: 'Word',
  [FileType.Pdf]: 'PDF',
  [FileType.Table]: 'Table',
  [FileType.Text]: 'Text',
  [FileType.ThreeD]: '3D',
  [FileType.Vector]: 'Vector',
  [FileType.Video]: 'Video',
  [FileType.Zip]: 'Archive',
}

export function friendlyFileType(type: FileType): string {
  return FILE_TYPE_LABELS[type] ?? type
}

export function getEntityInfo(entity: FileEntity): {
  id: string
  name: string
  avatarUrl: string
} {
  return {
    id: entity.id,
    name: entity.name,
    avatarUrl: entity.avatar.url,
  }
}
